import React from "react";
import { Layout, Menu, Dropdown, Button } from "antd";
import { UserOutlined, DownOutlined } from "@ant-design/icons";

const { Header } = Layout;

export default function HeaderBar() {
  const menu = (
    <Menu
      items={[
        { key: "profile", label: "Profile" },
        { key: "settings", label: "Settings" },
        { key: "logout", label: "Logout" },
      ]}
    />
  );

  return (
    <Header
      style={{
        background: "#fff",
        padding: "0 20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* Left side: logo + site name */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <img
          src="/logo.png"
          alt="MHD - Madagascar Holidays Dreams"
          style={{ height: "48px" }}
        />
        <span style={{ fontWeight: "bold", fontSize: "18px", color: "#008080" }}>
          MHD – Madagascar Holidays Dreams
        </span>
      </div>

      {/* Right side: user dropdown */}
      <Dropdown overlay={menu} trigger={["click"]}>
        <Button icon={<UserOutlined />}>
          Admin <DownOutlined />
        </Button>
      </Dropdown>
    </Header>
  );
}
